export default __webpack_public_path__ + "static/media/iphone-13.d4876837.webp";